import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="m93.38 100.629 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM72.3 99.14a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M24.62 60.72h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M40.94 13c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#D8FFFF"
      d="M58.278 31.44c-1.24 0-2.25-1.01-2.25-2.25v-7.97c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v7.97c0 1.24-1.01 2.25-2.25 2.25M52.088 83.11c0 3.42 2.77 6.19 6.19 6.19s6.19-2.77 6.19-6.19z"
    />
    <path
      fill="#00D8D8"
      d="M83.038 58.35c0-15.47-10.57-29.17-24.76-29.17s-24.76 13.69-24.76 29.17c0 2.45-.1 4.68-.27 6.7h50.06c-.17-2.02-.27-4.25-.27-6.7"
    />
    <path
      fill="#0597A3"
      d="M83.308 65.05h-50.06c-.69 8.12-2.57 12.89-4.02 15.47-.66 1.16.19 2.59 1.53 2.59h55.06c1.33 0 2.19-1.43 1.53-2.59-1.46-2.59-3.34-7.38-4.04-15.48z"
    />
    <path
      fill="#D8FFFF"
      d="M108.31 33.8c-.83 0-1.63-.46-2.02-1.26a48.9 48.9 0 0 0-17.52-19.67 2.25 2.25 0 0 1-.68-3.11 2.25 2.25 0 0 1 3.11-.68 53.4 53.4 0 0 1 19.14 21.48 2.25 2.25 0 0 1-2.02 3.24zM96.97 38.62c-.83 0-1.63-.46-2.02-1.26a40.85 40.85 0 0 0-10.99-13.77c-.97-.78-1.12-2.2-.34-3.16.78-.97 2.2-1.12 3.16-.34 5.11 4.12 9.33 9.41 12.21 15.3a2.25 2.25 0 0 1-2.02 3.24zM6.86 34.03c-.32 0-.64-.07-.95-.21a2.24 2.24 0 0 1-1.09-2.99 53.33 53.33 0 0 1 18.7-21.86c1.03-.69 2.43-.42 3.12.62.69 1.03.42 2.43-.62 3.12A48.94 48.94 0 0 0 8.89 32.73c-.38.82-1.19 1.3-2.04 1.3zM18.29 38.62c-.32 0-.64-.07-.95-.21a2.24 2.24 0 0 1-1.09-2.99 45.5 45.5 0 0 1 11.9-15.54 2.25 2.25 0 0 1 2.9 3.44 40.8 40.8 0 0 0-10.71 13.99c-.38.82-1.19 1.3-2.04 1.3zM101.7 55.57a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
  </svg>
);
const SvgEnrichedIconRemindersBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconRemindersBrand);
export default Memo;
